(function ($) {
    // Handler for .ready() called.
    var processing;
    /** Custom Validator**/
    $.validator.addMethod("alphaonly", function (value, element) {
        var regex = new RegExp("^[a-zA-Z ]+$"); //[a-zA-Z0-9]
        var key = value;

        if (!regex.test(key)) {
            return false;
        }
        return true;
    }, "Please use only alphabetic characters or space.");

    //Validation for ABS form
    $.validator.addMethod("alphanum", function (value, element) {
        var regex = new RegExp("^[-a-zA-Z0-9_\\-!&#*'\" ]+$"); //[a-zA-Z0-9]
        var key = value;

        if (!regex.test(key)) {
            return false;
        }
        return true;
    }, "Please use only alphanumeric characters.");

    $.validator.addMethod("validPhone", function (value, element) {
        value = value.replace(/[^0-9\-]/g, '');
        this.optional(element) || !value.match(/\d{3}-?\d{3}-?\d{4}$/); ///1-?\d{3}-?\d{3}-?\d{4}$
    }, "Please specify a valid phone number.");

    $.validator.addMethod("simplePhone", function(value, element) {
        return this.optional(element) || /^[0-9\(\)\+\-]+$/.test(value);
    }, "Please enter a valid phone number with numbers, parentheses, dashes and + only.");
      

    $.validator.addMethod("notempty", function (value, element) {
        var key = value,
            tempValue = $.trim(value);

        if (tempValue == '') {
            return false;
        }
        return true;
    }, "Please enter a value.");

    $.validator.addMethod("nophp", function (value, element) {
        value = _convertSpecialChars(value);
        if (/<\?[=|php]?[\s\S]*?\?>/i.test(value)) {
            return false;
        }
        return true;
    }, "Only plain text allowed.");

    $.validator.addMethod("nohtml", function (value, element) {
        value = _convertSpecialChars(value);
        if (/<\/?[a-z][\s\S]*>/i.test(value)) {
            return false;
        }
        return true;
    }, "No html allowed.");

    $.validator.addMethod("turnstileRequiredIfVisible", function(value, element) {
        var $wrapper = $('.cf-turnstile');
        var isWidgetVisible = $wrapper.length > 0 && $wrapper.is(':visible') && $wrapper.height() > 0;

        // If Turnstile is rendered visually on screen, require a non-empty token
        if (isWidgetVisible) {
            return $.trim(value) !== "";
        }

        // If hidden/not rendered, pass validation automatically
        return true;
    }, "Please complete the security check.");

    function _convertSpecialChars(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    $('select').on('change', function () {
        if(!isEmpty($(this).val())){
            $(this).addClass('dirty');
        } else {
            $(this).removeClass('dirty');
        }
    });

    $("#reg-frm").validate({
        ignore: [],
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.appendTo(element.parents('.field-input'));
        },
        highlight: function (element) {
            $(element).parents('.field-input').addClass('has-error');
        },
        unhighlight: function (element) {
            $(element).parents('.field-input').removeClass('has-error');
        },
        rules: {
            'entry[fullname]': { required: true, notempty: true, nohtml: true, nophp: true },
            'entry[title]': { nohtml: true, nophp: true },
            'entry[email]': { required: true, email: true, notempty: true, nohtml: true, nophp: true },
            'entry[organization]': { nohtml: true, nophp: true },
            'cf-turnstile-response': { turnstileRequiredIfVisible: true },
        },
        messages: {
            'entry[fullname]': { required: 'Please enter your full name.' },
            'entry[email]': { required: 'Please enter your email address.', email: 'Please enter a valid email address.' },
        },
        invalidHandler: function (event, validator) {
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).parents('.field-group').offset().top
            }, 800);
        },
        submitHandler: function (form) {
            //new FormData(this),
            processForm(new FormData(form));
            //processEntry('form', $(form).serialize());
            return false;
        }
    });

    
    $('.goto').on('click', function(e){
        e.preventDefault();
        var _target = null;
        if($('#' + $(this).data('section')).length > 0){
          _target = $('#' + $(this).data('section'));
        } else if($('.' + $(this).data('section')).length > 0){
          _target = $('.' + $(this).data('section'));
          $('button.video-section__poster').trigger('click');
        }
        if(_target !== null){
          $('html, body').animate({
              scrollTop: _target.offset().top - 20,
          }, 1200);
        }
    });
    
    //Create expression and trap all external links
    $.expr[':'].external = function (obj) {
        return !obj.href.match(/^mailto\:/)
            && (obj.hostname != location.hostname);
    };

    $('a[href$=".pdf"]').prop('target', '_blank').addClass('pdf');
    $('a:external:not(.sub)').addClass('external-link');
    $('.external-link').attr('aria-describedby', 'off-site');
    $('a[href="#"]').attr('role', 'button');
    var externalLink;
    checkingProcessing = false;
    $('.btn.share').on('click', function(){
        _addShareEntry();
    });

    $('.checkin-guest').on('click', function(){
        if(checkingProcessing){
           return;
        }
        checkinGuest($(this));
    });

    function checkinGuest(obj){
        checkingProcessing = true;
        obj.addClass('loading');
        formData = new FormData();
        formData.append("token", obj.data('token'));
        formData.append("op", 'checkin');
        $('#response-cont .resp-box').fadeOut();
        $.ajax({
            type: "POST",
            dataType: 'json',
            url: '../misc/ajax.php',
            data: formData,
            encode: true,
            contentType: false,
            cache: false,
            processData:false,
            beforeSend: function (xhr) {
            }
        })
        .done(function (resp) {
            if (!isEmpty(resp.success)) {
                $('.checkin-guest').fadeOut(200).remove();
                $('#response-cont .resp-box.success').fadeIn();
            } else if (!isEmpty(resp.error)) {
                $('#response-cont .resp-box.error').fadeIn();
            }
        })
        .fail(function () {
            // Some Error Occured
        })
        .always(function (data) {
            checkingProcessing = false;
            obj.removeClass('loading');
        });
    }

    function prepareFormSubmissionPayload() {
        var isHeadless = false;

        try {
            // 1. Webdriver flag check
            if (navigator.webdriver) {
                isHeadless = true;
            }

            // 2. User-Agent string check
            if (/HeadlessChrome|PhantomJS|jsdom/i.test(navigator.userAgent)) {
                isHeadless = true;
            }

            // 3. WebGL Driver check (safely wrapped)
            var canvas = document.createElement('canvas');
            var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
            if (gl) {
                var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
                if (debugInfo) {
                    var renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || '';
                    if (/SwiftShader|llvmpipe|VirtualBox/i.test(renderer)) {
                        isHeadless = true;
                    }
                }
            }
        } catch (e) {
            // If anything errors out (e.g. strict privacy blockers), default to human (false)
            isHeadless = false;
        }

        return {
            bcheck: isHeadless ? 'failed' : 'passed'
        };
    }


    function _addShareEntry(){
        $('#error-bucket, #success-bucket').fadeOut().remove();
        if (processing) {
            return;
        }

        processing = true;
        formData = new FormData();
        formData.append('op', 'share-entry');
        $.ajax({
            type: "POST",
            // dataType: 'json',
            url: 'misc/ajax.php',
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
        })
            .done(function (resp) {
               //Don't need to do anything
            })
            .fail(function () {
                // Some Error Occured
            })
            .always(function (data) {
                processing = false;
            });
    }

    function processForm(formData) {
        $('#error-bucket, #success-bucket').fadeOut().remove();
        if (processing) {
            alert('Your submission is being processed, please wait.');
            return;
        }

        var button = $('.frm-submit');
        button.addClass('loading');
        processing = true;
        var envCheck = prepareFormSubmissionPayload();
        formData.append('op', 'form-submission');
        formData.append('bcheck', envCheck.bcheck);

        $.ajax({
            type: "POST",
            // dataType: 'json',
            url: 'misc/ajax.php',
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
            beforeSend: function (xhr) {
                $("#err").fadeOut();
            }
        })
            .done(function (resp) {
                if (!isEmpty(resp.success)) {
                    if(resp.redirect == 'inline'){
                        $('#frm-wrapper').slideUp(250, function(){
                            $('#thank-you').slideDown();
                            setTimeout(() => {
                                $('#main-content').slideDown(250, function(){
                                    $('html, body').animate({
                                        scrollTop: $('#main-content').offset().top
                                    }, 800);
                                });
                            }, 2000);
                        });
                    } else{
                        window.location = resp.redirect;
                    }
                } else if (!isEmpty(resp.error)) {
                    if ($('#reg-frm, #friend-frm').length > 0) {
                        $('#reg-frm, #friend-frm').prepend('<div id="error-bucket">' + resp.error + '</div>');
                    }
                }
            })
            .fail(function () {
                // Some Error Occured
            })
            .always(function (data) {
                processing = false;
                // if($('.captcha-cont').length > 0){
                //     grecaptcha.reset();
                // }
                button.removeClass('loading');
                if ($('#error-bucket').length > 0) {
                    $('html, body').animate({
                        scrollTop: $('#error-bucket').offset().top - 10
                    }, 800);
                }
            });
    }


    function _resetform(){
        $("#reg-frm")[0].reset();
        if ($('#success-bucket').length > 0) {
            $('html, body').animate({
                scrollTop: $('#success-bucket').offset().top - 10
            }, 1000);
        }
    }

    function isMobile() {
        return ($(window).width() < 768);
    }

    function isEmpty(mixed_var) {
        mixed_var = jQuery.trim(mixed_var);
        var key;
        if (mixed_var === '' || mixed_var === 0 || mixed_var === '0' || mixed_var === null || mixed_var === false || typeof mixed_var === 'undefined') {
            return true;
        }

        if (typeof mixed_var === 'object') {
            for (key in mixed_var) {
                return false;
            }
            return true;
        }
        return false;
    }


    //Video Player Handling
    document.addEventListener('DOMContentLoaded', () => {
        const iframe = document.getElementById('videoIframe');
        const poster = document.getElementById('videoPoster');

        if (iframe && poster) {
            // Initialize Vimeo Player API Instance
            const player = new Vimeo.Player(iframe);

            // 1. Click poster -> Hide poster & Play video
            poster.addEventListener('click', () => {
                poster.classList.add('is-hidden');
                player.play();
            });

            // 2. Video paused -> Show poster again
            player.on('pause', () => {
                poster.classList.remove('is-hidden');
            });

            // 3. Video ended -> Show poster again
            player.on('ended', () => {
                poster.classList.remove('is-hidden');
            });
        }
    });

})(jQuery);